import { getTranslateByKey } from '@/main/services/utils';
import styled from 'styled-components';

const ContainerModalConfirmation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  text-align: center;

  .title {
    font-size: 14px;
    font-weight: 400;
  }

  .list {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    font-weight: 600;

    width: fit-content;
    margin: 0 auto;

    text-align: left;
  }

  .question {
    margin-top: 0.5rem;
    font-size: 14px;
  }

  p {
    margin: 0;
    white-space: nowrap;
  }
`;

interface ISupplierIgnoreConfirm {
  resultData: { supplierInfo: string }[];
}

export default function SupplierIgnoreConfirm({
  resultData
}: Readonly<ISupplierIgnoreConfirm>) {
  return (
    <ContainerModalConfirmation>
      <span className="title">
        {getTranslateByKey('information.suppliersDoNotSupportPartTypes')}
      </span>

      <div className="list">
        {resultData.map((i, index) => (
          <p key={index}>{i.supplierInfo}</p>
        ))}
      </div>

      <span className="question">
        {getTranslateByKey('information.continueAnyway')}
      </span>
    </ContainerModalConfirmation>
  );
}
